import { nxConfig } from '@nv/utils'
import axios from 'axios'

export const PublicAxiosInstance = axios.create({
  withCredentials: true,
  headers: {},
  baseURL: `${nxConfig.PUBLIC_URL}`,
})

// attach access token
PublicAxiosInstance.interceptors.request.use(
  async (config) => {
    return config
  },
  (error) => {
    Promise.reject(error)
  },
)

// flattens the layer of nested introduced by axios
// the responses look like { data, error }, but axios nests the whole response under 'data'
PublicAxiosInstance.interceptors.response.use(
  (res: any) => {
    res = res.data
    return res
  },
  async (err) => {
    const error = {
      ...err.response?.data?.error,
      ...err,
    }
    return Promise.reject(error)
  },
)

export default PublicAxiosInstance
